//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class AccountManagementClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Add an Account Holder (without any details)
     * @return Success
     */
    addAccountHolder(): Promise<AddAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccountHolder(_response);
        });
    }

    protected processAddAccountHolder(response: Response): Promise<AddAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddAccountHolder_Response_Root>(null as any);
    }

    /**
     * Get account holder details for the currently logged in User
     * @return Success
     */
    getAccountHolder(): Promise<GetAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountHolder(_response);
        });
    }

    protected processGetAccountHolder(response: Response): Promise<GetAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountHolder_Response_Root>(null as any);
    }

    /**
     * Add an account to an account holder
     * @return Success
     */
    addAccountToAccountHolder(root: AddAccountToAccountHolder_Request_Root, accountHolderId: string): Promise<AddAccountToAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/account";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccountToAccountHolder(_response);
        });
    }

    protected processAddAccountToAccountHolder(response: Response): Promise<AddAccountToAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAccountToAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddAccountToAccountHolder_Response_Root>(null as any);
    }

    /**
     * Add a bank account to an account holder
     * @return Success
     */
    addBankDetailsToAccountHolder(request: AddBankDetailsToAccountHolder_Request, accountHolderId: string): Promise<AddBankDetailsToAccountHolder_Response> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/bank-account";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddBankDetailsToAccountHolder(_response);
        });
    }

    protected processAddBankDetailsToAccountHolder(response: Response): Promise<AddBankDetailsToAccountHolder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddBankDetailsToAccountHolder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddBankDetailsToAccountHolder_Response>(null as any);
    }

    /**
     * Get the specified account
     * @return Success
     */
    getAccount(accountId: string): Promise<GetAccount_Response> {
        let url_ = this.baseUrl + "/api/account-management/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccount(_response);
        });
    }

    protected processGetAccount(response: Response): Promise<GetAccount_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccount_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccount_Response>(null as any);
    }

    /**
     * Get all accounts for an account holder
     * @return Success
     */
    getAccountsByAccountHolder(accountHolderId: string): Promise<GetAccountsByAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/accounts";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountsByAccountHolder(_response);
        });
    }

    protected processGetAccountsByAccountHolder(response: Response): Promise<GetAccountsByAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountsByAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountsByAccountHolder_Response_Root>(null as any);
    }

    /**
     * Get the current onboarding stage for the user
     * @return Success
     */
    getOnboardingStage(): Promise<GetOnboardingStage_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/onboarding/stage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOnboardingStage(_response);
        });
    }

    protected processGetOnboardingStage(response: Response): Promise<GetOnboardingStage_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnboardingStage_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOnboardingStage_Response_Root>(null as any);
    }

    /**
     * Get all openable accounts for the current user
     * @return Success
     */
    getOpenableAccountsForAccountHolder(accountHolderId: string): Promise<GetOpenableAccountsForAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/accounts/openable";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOpenableAccountsForAccountHolder(_response);
        });
    }

    protected processGetOpenableAccountsForAccountHolder(response: Response): Promise<GetOpenableAccountsForAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOpenableAccountsForAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOpenableAccountsForAccountHolder_Response_Root>(null as any);
    }

    /**
     * @return Success
     */
    getWealthKernelAccountSyncingHealth(userId: string): Promise<GetWealthKernelAccountSyncingHealth_Response> {
        let url_ = this.baseUrl + "/api/account-management/{userId}/account-syncing-health";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWealthKernelAccountSyncingHealth(_response);
        });
    }

    protected processGetWealthKernelAccountSyncingHealth(response: Response): Promise<GetWealthKernelAccountSyncingHealth_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWealthKernelAccountSyncingHealth_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWealthKernelAccountSyncingHealth_Response>(null as any);
    }

    /**
     * Make a declaration for the specified account
     * @return The declaration was successfully created
     */
    makeDeclaration(accountGlobalId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/accounts/{accountGlobalId}/make-declaration";
        if (accountGlobalId === undefined || accountGlobalId === null)
            throw new Error("The parameter 'accountGlobalId' must be defined.");
        url_ = url_.replace("{accountGlobalId}", encodeURIComponent("" + accountGlobalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMakeDeclaration(_response);
        });
    }

    protected processMakeDeclaration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update account holder (and address)
     * @return Success
     */
    updateAccountHolder(root: UpdateAccountHolder_Request_Root, accountHolderId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAccountHolder(_response);
        });
    }

    protected processUpdateAccountHolder(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Pings the account management service to avoid long cold starts
     * @return Success
     */
    warmup(): Promise<any> {
        let url_ = this.baseUrl + "/api/account-management/warmup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarmup(_response);
        });
    }

    protected processWarmup(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class AddAccountHolder_Response_Root implements IAddAccountHolder_Response_Root {
    accountHolderId?: string;

    constructor(data?: IAddAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderId = _data["accountHolderId"];
        }
    }

    static fromJS(data: any): AddAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderId"] = this.accountHolderId;
        return data;
    }
}

export interface IAddAccountHolder_Response_Root {
    accountHolderId?: string;
}

export class AddAccountToAccountHolder_Response_Root implements IAddAccountToAccountHolder_Response_Root {
    accountId?: string;

    constructor(data?: IAddAccountToAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): AddAccountToAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountToAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IAddAccountToAccountHolder_Response_Root {
    accountId?: string;
}

/** the dto used to send an error response to the client */
export class FastEndpointsErrorResponse implements IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IFastEndpointsErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusCode = 400;
            this.message = "One or more errors occurred!";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : 400;
            this.message = _data["message"] !== undefined ? _data["message"] : "One or more errors occurred!";
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): FastEndpointsErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FastEndpointsErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

export class AddAccountToAccountHolder_Request_Root implements IAddAccountToAccountHolder_Request_Root {
    accountType?: AccountType;

    constructor(data?: IAddAccountToAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): AddAccountToAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountToAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IAddAccountToAccountHolder_Request_Root {
    accountType?: AccountType;
}

export enum AccountType {
    Isa = "Isa",
    Gia = "Gia",
}

export class AddBankDetailsToAccountHolder_Response implements IAddBankDetailsToAccountHolder_Response {
    bankAccountId?: string;

    constructor(data?: IAddBankDetailsToAccountHolder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAccountId = _data["bankAccountId"];
        }
    }

    static fromJS(data: any): AddBankDetailsToAccountHolder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AddBankDetailsToAccountHolder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccountId"] = this.bankAccountId;
        return data;
    }
}

export interface IAddBankDetailsToAccountHolder_Response {
    bankAccountId?: string;
}

export class AddBankDetailsToAccountHolder_Request implements IAddBankDetailsToAccountHolder_Request {
    accountName!: string;
    sortCode!: string;
    accountNumber!: string;

    constructor(data?: IAddBankDetailsToAccountHolder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.sortCode = _data["sortCode"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): AddBankDetailsToAccountHolder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AddBankDetailsToAccountHolder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["sortCode"] = this.sortCode;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IAddBankDetailsToAccountHolder_Request {
    accountName: string;
    sortCode: string;
    accountNumber: string;
}

export class GetAccount_Response implements IGetAccount_Response {
    accountType?: AccountType;
    status?: AccountStatus | undefined;

    constructor(data?: IGetAccount_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetAccount_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccount_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetAccount_Response {
    accountType?: AccountType;
    status?: AccountStatus | undefined;
}

export enum AccountStatus {
    Active = "Active",
    TradingAllowed = "TradingAllowed",
}

export class GetAccount_Request implements IGetAccount_Request {

    constructor(data?: IGetAccount_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAccount_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccount_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAccount_Request {
}

export class GetAccountHolder_Response_Root implements IGetAccountHolder_Response_Root {
    accountHolderId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nino?: string | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
    canUpdate?: boolean;
    currentAddress?: GetAccountHolder_Response_AddressModel | undefined;
    currentBankDetails?: GetAccountHolder_Response_BankDetailsModel | undefined;
    rowVersion?: number;

    constructor(data?: IGetAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderId = _data["accountHolderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.isUkTaxResident = _data["isUkTaxResident"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.nino = _data["nino"];
            this.nationality = _data["nationality"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.employmentStatus = _data["employmentStatus"];
            this.industry = _data["industry"];
            if (Array.isArray(_data["sourcesOfWealth"])) {
                this.sourcesOfWealth = [] as any;
                for (let item of _data["sourcesOfWealth"])
                    this.sourcesOfWealth!.push(item);
            }
            this.annualIncome = _data["annualIncome"];
            this.canUpdate = _data["canUpdate"];
            this.currentAddress = _data["currentAddress"] ? GetAccountHolder_Response_AddressModel.fromJS(_data["currentAddress"]) : <any>undefined;
            this.currentBankDetails = _data["currentBankDetails"] ? GetAccountHolder_Response_BankDetailsModel.fromJS(_data["currentBankDetails"]) : <any>undefined;
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderId"] = this.accountHolderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["isUkTaxResident"] = this.isUkTaxResident;
        data["isUsCitizen"] = this.isUsCitizen;
        data["nino"] = this.nino;
        data["nationality"] = this.nationality;
        data["countryOfBirth"] = this.countryOfBirth;
        data["employmentStatus"] = this.employmentStatus;
        data["industry"] = this.industry;
        if (Array.isArray(this.sourcesOfWealth)) {
            data["sourcesOfWealth"] = [];
            for (let item of this.sourcesOfWealth)
                data["sourcesOfWealth"].push(item);
        }
        data["annualIncome"] = this.annualIncome;
        data["canUpdate"] = this.canUpdate;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["currentBankDetails"] = this.currentBankDetails ? this.currentBankDetails.toJSON() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetAccountHolder_Response_Root {
    accountHolderId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nino?: string | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
    canUpdate?: boolean;
    currentAddress?: GetAccountHolder_Response_AddressModel | undefined;
    currentBankDetails?: GetAccountHolder_Response_BankDetailsModel | undefined;
    rowVersion?: number;
}

export class GetAccountHolder_Response_AddressModel implements IGetAccountHolder_Response_AddressModel {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
    rowVersion?: number;

    constructor(data?: IGetAccountHolder_Response_AddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.line3 = _data["line3"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.countryCode = _data["countryCode"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetAccountHolder_Response_AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolder_Response_AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["line3"] = this.line3;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["countryCode"] = this.countryCode;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetAccountHolder_Response_AddressModel {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
    rowVersion?: number;
}

export class GetAccountHolder_Response_BankDetailsModel implements IGetAccountHolder_Response_BankDetailsModel {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;

    constructor(data?: IGetAccountHolder_Response_BankDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): GetAccountHolder_Response_BankDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolder_Response_BankDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["sortCode"] = this.sortCode;
        return data;
    }
}

export interface IGetAccountHolder_Response_BankDetailsModel {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;
}

export class GetAccountsByAccountHolder_Response_Root implements IGetAccountsByAccountHolder_Response_Root {
    accounts?: GetAccountsByAccountHolder_Response_Account[] | undefined;

    constructor(data?: IGetAccountsByAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(GetAccountsByAccountHolder_Response_Account.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAccountsByAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountsByAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAccountsByAccountHolder_Response_Root {
    accounts?: GetAccountsByAccountHolder_Response_Account[] | undefined;
}

export class GetAccountsByAccountHolder_Response_Account implements IGetAccountsByAccountHolder_Response_Account {
    id?: string;
    accountType?: AccountType;

    constructor(data?: IGetAccountsByAccountHolder_Response_Account) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): GetAccountsByAccountHolder_Response_Account {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountsByAccountHolder_Response_Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IGetAccountsByAccountHolder_Response_Account {
    id?: string;
    accountType?: AccountType;
}

export class GetAccountsByAccountHolder_Request_Root implements IGetAccountsByAccountHolder_Request_Root {

    constructor(data?: IGetAccountsByAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAccountsByAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountsByAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAccountsByAccountHolder_Request_Root {
}

export class GetOnboardingStage_Response_Root implements IGetOnboardingStage_Response_Root {
    stage?: GetOnboardingStage_OnboardingStage;

    constructor(data?: IGetOnboardingStage_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): GetOnboardingStage_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnboardingStage_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        return data;
    }
}

export interface IGetOnboardingStage_Response_Root {
    stage?: GetOnboardingStage_OnboardingStage;
}

export enum GetOnboardingStage_OnboardingStage {
    NotStarted = "NotStarted",
    InitialDetails = "InitialDetails",
    PersonalDetails = "PersonalDetails",
    AccountSelection = "AccountSelection",
    KYCChecks = "KYCChecks",
    BankDetails = "BankDetails",
    Complete = "Complete",
}

export class GetOpenableAccountsForAccountHolder_Response_Root implements IGetOpenableAccountsForAccountHolder_Response_Root {
    accounts?: AccountType[] | undefined;

    constructor(data?: IGetOpenableAccountsForAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
        }
    }

    static fromJS(data: any): GetOpenableAccountsForAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenableAccountsForAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        return data;
    }
}

export interface IGetOpenableAccountsForAccountHolder_Response_Root {
    accounts?: AccountType[] | undefined;
}

export class GetOpenableAccountsForAccountHolder_Request_Root implements IGetOpenableAccountsForAccountHolder_Request_Root {

    constructor(data?: IGetOpenableAccountsForAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOpenableAccountsForAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenableAccountsForAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOpenableAccountsForAccountHolder_Request_Root {
}

export class GetWealthKernelAccountSyncingHealth_Response implements IGetWealthKernelAccountSyncingHealth_Response {
    accounts?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse[] | undefined;

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(GetWealthKernelAccountSyncingHealth_Response_AccountResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Response {
    accounts?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse[] | undefined;
}

export class GetWealthKernelAccountSyncingHealth_Response_AccountResponse implements IGetWealthKernelAccountSyncingHealth_Response_AccountResponse {
    id?: string;
    accountType?: string | undefined;
    syncStages?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse[] | undefined;

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Response_AccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountType = _data["accountType"];
            if (Array.isArray(_data["syncStages"])) {
                this.syncStages = [] as any;
                for (let item of _data["syncStages"])
                    this.syncStages!.push(GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Response_AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Response_AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountType"] = this.accountType;
        if (Array.isArray(this.syncStages)) {
            data["syncStages"] = [];
            for (let item of this.syncStages)
                data["syncStages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Response_AccountResponse {
    id?: string;
    accountType?: string | undefined;
    syncStages?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse[] | undefined;
}

export class GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse implements IGetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse {
    order?: number;
    description?: string | undefined;
    status?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse_StatusResponse;

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse {
    order?: number;
    description?: string | undefined;
    status?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse_StatusResponse;
}

export enum GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse_StatusResponse {
    Complete = "Complete",
    Incomplete = "Incomplete",
    NotApplicable = "NotApplicable",
}

export class GetWealthKernelAccountSyncingHealth_Request implements IGetWealthKernelAccountSyncingHealth_Request {

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Request {
}

export class MakeDeclaration_Request implements IMakeDeclaration_Request {

    constructor(data?: IMakeDeclaration_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MakeDeclaration_Request {
        data = typeof data === 'object' ? data : {};
        let result = new MakeDeclaration_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMakeDeclaration_Request {
}

export class UpdateAccountHolder_Request_Root implements IUpdateAccountHolder_Request_Root {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    nino?: string | undefined;
    currentAddress?: UpdateAccountHolder_Request_Address | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;

    constructor(data?: IUpdateAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.isUkTaxResident = _data["isUkTaxResident"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.nationality = _data["nationality"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.nino = _data["nino"];
            this.currentAddress = _data["currentAddress"] ? UpdateAccountHolder_Request_Address.fromJS(_data["currentAddress"]) : <any>undefined;
            this.employmentStatus = _data["employmentStatus"];
            this.industry = _data["industry"];
            if (Array.isArray(_data["sourcesOfWealth"])) {
                this.sourcesOfWealth = [] as any;
                for (let item of _data["sourcesOfWealth"])
                    this.sourcesOfWealth!.push(item);
            }
            this.annualIncome = _data["annualIncome"];
        }
    }

    static fromJS(data: any): UpdateAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["isUkTaxResident"] = this.isUkTaxResident;
        data["isUsCitizen"] = this.isUsCitizen;
        data["nationality"] = this.nationality;
        data["countryOfBirth"] = this.countryOfBirth;
        data["nino"] = this.nino;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["employmentStatus"] = this.employmentStatus;
        data["industry"] = this.industry;
        if (Array.isArray(this.sourcesOfWealth)) {
            data["sourcesOfWealth"] = [];
            for (let item of this.sourcesOfWealth)
                data["sourcesOfWealth"].push(item);
        }
        data["annualIncome"] = this.annualIncome;
        return data;
    }
}

export interface IUpdateAccountHolder_Request_Root {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    nino?: string | undefined;
    currentAddress?: UpdateAccountHolder_Request_Address | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
}

export class UpdateAccountHolder_Request_Address implements IUpdateAccountHolder_Request_Address {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IUpdateAccountHolder_Request_Address) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.line3 = _data["line3"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UpdateAccountHolder_Request_Address {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountHolder_Request_Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["line3"] = this.line3;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IUpdateAccountHolder_Request_Address {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}